module.exports = __webpack_public_path__ + "static/assets/f6fcd0d885c7e2a50ae71adccf92a99f.png";